
// * ========================================================================
// * municipality chart and table
// * ========================================================================

import CovidChart from './covid-chart.js';
import moment from 'moment';
import dataHandler from './../data-handler';
import storage from './../storage';
import municipalityData from './municipality-data';
import { changeDates } from './../helpers';

const municipality = (function(){
    const typeSelectorClass = 'input[name=municipality-chart-data]';

    let thisChart = null;
    let dataType = null;
    let typeSelectors = null;
    let chartData = null;
    let chartFirstDate = null;
    let selectedMunicipalities = [];
    let dateElems = null;

    function createChartData(data, options) {
        const datasets = [];
        const dates = {};

        let idx = 0;
        for (const key of Object.keys(data.municipalities)) {
            const municipality = data.municipalities[key];

            if (municipality.count > 0) {
                datasets.push({
                    label: key,
                    name: key,
                    id: municipality.id,
                    borderColor: options.largeColorPalette[idx],
                    borderWidth: 3,
                    count: municipality.count,
                    fill: false,
                    data: [],
                    pointRadius: 0,
                    type: 'LineWithLine'
                });

                if (selectedMunicipalities.length) {
                    datasets[idx].selected = selectedMunicipalities.indexOf(datasets[idx].id) !== -1;
                }

                const rateString = 'rate_' + window.config.rateDays;

                // Per date
                if (data.municipality && typeof data.municipality[key] !== 'undefined') {
                    for (const day of data.municipality[key].days) {
                        if (typeof dates[day.date] === 'undefined') {
                            dates[day.date] = moment(day.date);
                            dates[day.date].set({
                                hour: 0,
                                minute: 0,
                                second: 0
                            });
                        }

                        const newDate = dates[day.date];
                        if (newDate >= chartFirstDate) {
                            let count;
                            if (dataType === 'date') {
                                count = day.count - data.municipality[key].firstDayValue;
                            } else if (dataType === 'rate') {
                                count = day[rateString] && day[rateString] > 0 ? day[rateString] : 0;
                            } else {
                                count = day.count;
                            }

                            datasets[idx].data.push({
                                x: newDate,
                                y: count
                            });
                        }
                    }
                }

                idx++;
            }
        }

        return datasets;
    }

    function getDataType() {
        dataType = document.querySelector(typeSelectorClass+':checked').value;
        return dataType;
    }

    function updateFirstDayValues() {
        const municipalityChartFirstDay = dataHandler.setFirstDayValues(chartData.municipality, null);
        window.config.firstDayValues['municipalities'] = municipalityChartFirstDay;

        // Update chart date elems
        changeDates(municipalityChartFirstDay, dateElems);
    }

    function getSelectedMunicipalityIds() {
        const selectedIds = [];
        const selected = document.querySelectorAll('input[name="municipality-multi-select"]:checked');
        selected.forEach(function(input) {
            selectedIds.push(input.value);
        });

        selectedMunicipalities = selectedIds;

        return selectedMunicipalities;
    }

    function updateChartData() {
        const datasets = createChartData(chartData, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    function updateSelected() {
        const selectedIds = getSelectedMunicipalityIds();
        municipalityData.load(chartData, selectedIds, updateChartData);
    }

    function initChart(data) {
        chartData = data;

        dateElems = document.querySelectorAll('.js-date-municipalities');
        updateFirstDayValues();

        chartFirstDate = window.config.firstDayValues['municipalities'];

        typeSelectors = document.querySelectorAll(typeSelectorClass);
        getDataType();

        const datasets = createChartData(chartData, window.config);

        thisChart = new CovidChart('municipality-total-chart', {
            datasets,
            chartOptions: {
                options: {
                    plugins: {
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                            position: 'nearest',
                            bodySpacing: 5,
                            itemSort: function(a, b, data) {
                                return b.parsed.y > a.parsed.y ? 1 : -1;
                            },
                        },
                    },
                    scales: {
                        y: {
                            title: {
                                display: false,
                                text: 'Tartuntojen määrä'
                            },
                            ticks: {
                                precision: 0,
                                beginAtZero: true,
                                min: 0
                            }
                        }
                    }
                }
            },
            config: window.config,
            tooltips: {
                elementId: 'municipality-total-chart-tooltip'
            },
            multiselect: {
                requireCount: true,
                sortData: 'name',
                colorField: 'borderColor',
                inputName: 'municipality-multi-select',
                selectElemId: 'municipality-multiselect',
                colorElemId: 'municipality-multiselect-colors',
                countElemId: 'municipality-multiselect-count',
                onChangeCallback: updateSelected
            },
            responsive: ['aspectRatio']
        });

        // Create listener for type change
        typeSelectors.forEach((typeSelector) => {
            typeSelector.addEventListener('change', () => {
                let newType = document.querySelector(typeSelectorClass+':checked').value;
                if (dataType !== newType) {
                    reload(null, true);
                }
            });
        });
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     * @param {Object} options - chart options
     */
    function init(data, options) {
        chartData = data;

        // Initially selected
        selectedMunicipalities = storage.getData('municipality-total-chart_multiselect');
        if (!selectedMunicipalities || !Array.isArray(selectedMunicipalities)) {
            selectedMunicipalities = ['445171']; // Helsinki for default
        }

        municipalityData.load(chartData, selectedMunicipalities, initChart);
    }

    function reload(data = null, changeType = false) {
        if (data) {
            chartData = data;
        }

        // Get the data type we want to show
        getDataType();

        chartFirstDate = window.config.firstDayValues['municipalities'];

        const datasets = createChartData(chartData, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default municipality;
